import { useCallback, useState } from 'react';
import { EditDescriptor } from '@progress/kendo-react-data-tools';
import { useEditComponentTable } from './useEditComponentTable';
import { GridItemChangeEvent, GridEditChangeEvent } from '@progress/kendo-react-grid';

export const useKendoInlineEdit = () => {
  const [edit, setEdit] = useState<EditDescriptor>({});
  const { saveSingleEdit, saveBulkEdit } = useEditComponentTable();

  const handleEditChange = useCallback((event: GridEditChangeEvent) => {
    setEdit(event.edit);
  }, []);

  const exitEdit = useCallback(() => {
    setEdit({});
  }, []);

  const itemChange = useCallback((event: GridItemChangeEvent) => {
    if (!event.field) return;
  }, []);

  return {
    edit,
    setEdit,
    handleEditChange,
    exitEdit,
    itemChange,
    saveSingleEdit,
    saveBulkEdit,
  };
};
